<template>
  <div class="page-list-articles">
    <CustomHead :head="head" />
    <Section class="page-articles__content" ref="article-top">
      <Heading
        tag="h1" 
        tagClass="h2"
        textBefore="Tous les contenus "
        :textBean="tag"
        colorBean="roman"
      /><br>
      <div class="mks-grid mks-grid-gap-lg" :key="tag+page">
        <div 
          class="mks-col-12 mks-col-6@sm mks-col-4@md"
          v-for="(article, index) in articles" 
          :key="index"
        >
          <ArticleTeaser :content="article" variant="flat" :key="article.id">
          </ArticleTeaser>
        </div>
      </div>
      <EmptyState v-if="!articles || articles.length < 1">
      </EmptyState>
      <mks-pagination
        v-else-if="total / articlesPerPage > 1"
        class="pagination"
        :total="Math.ceil(total / articlesPerPage)"
        :value="page"
        @change="updateCurrentPage"
      ></mks-pagination>
    </Section>
    <NewsletterHero source="chiche-articles-list"/>
  </div>
</template>
<script>
import { isPreviewing } from '@builder_sdk';
import { REGISTERED_COMPONENTS } from '@/init-builder.ts';
import { useAsyncData } from 'nuxt/app';
import { useRoute } from 'vue-router';
import Breadcrumbs from '~/components/molecules/Breadcrumbs.vue';
import MksPagination from "@DS/components/Pagination.vue";
import chicheMetas from '@/mixins/chicheMetas';

export default {
  components: {Breadcrumbs, MksPagination},
  mixins: [chicheMetas],
  data() {
    return {
      loading: true
    }
  },
  computed: {
    head() {
      const data = {
        titleSeo: `Tous les articles sur ${this.tag}`,
        descriptionSeo: `Envie de plonger dans un sujet en particulier ? On t'explique ${this.tag}`
      }
      if (this.articles) {
        const schemaArticles = this.articles.map(article => {
          return {
            type: 'article',
            data: article
          }
        })
        return this.getHead(data, [...schemaArticles], { type: 'search'});
      }
      else return this.getHead(data, [{ type: 'search'}]);
    },
    isPreviewing() { return isPreviewing() },
    apiKey() {
      return this.$env.builder.apiKey;
    },
    getCustomComponents() {
      return REGISTERED_COMPONENTS;
    },
    breadcrumbs() {
      return [
        {label: 'Accueil', path: '/'},
        {label: 'Média', path: '/media'},
        {label: this.tag, path: `/media/tag?tag=${tag}`},
      ]
    }
  },
  async setup() {
    const nuxtApp = useNuxtApp();
    const route = useRoute();

    if (nuxtApp.$env.SITE === 'international') {
      await navigateTo('/')
    }

    const previewing = route.query.previewing;
    const articlesPerPage = 20;
    const page = computed(() => route.query.page);
    const offset = computed(() => page.value ? articlesPerPage * (page.value - 1) : 0);
    const tag = route.query.tag;
    
    try {
      const { data: asyncArticles, refresh, pending } = await useAsyncData(() => nuxtApp.$builder.getAll('article', {
        options: {
          limit: articlesPerPage,
          offset: offset.value,
        },
        query: {
          data: {
            tags: route.query.tag
          }
        },
        includeUnpublished: previewing === 'true'
      }));
      const canShowArticles = !!asyncArticles.value || isPreviewing();
      return {
        articlesPerPage,
        articles: computed(() => asyncArticles.value.results),
        canShowArticles,
        total: computed(() => asyncArticles.value.count), 
        articlesPerPage, 
        page, 
        refresh,
        pending,
        tag
      };
    }
    catch (err) {
      console.log('in setup error');
      console.log(err);
      return { articles: [] }
    }
    
  },
  methods: {
    updateCurrentPage(page) {
      this.page = page - 1;
      console.log('update current page', this.page);
      this.$router.push({
        name: this.$route.name,
        query: Object.assign({}, { ...this.$route.query, page: page }),
        force: true,
      });
    },
  },
  watch: {
    '$route.query.page'() {
      this.refresh();
      this.$nextTick(() => {
        this.$refs["article-top"].$el.scrollIntoView();
      });
    }
  }
}
</script>
<style lang="scss" scoped>
$hero-offset: 20px;
.page-articles__header {
  text-align: center;
  padding-top: $space-m;
  margin-bottom: $hero-offset * -1;
}

.page-articles__content {
  margin-top: var(--header-height);
  // margin-top: calc($space-xl + $hero-offset);
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>